<template>
  <CockpitDialog
    title="处理意见"
    left="630px"
    width="360px"
    height="230px"
    top="120px"
    @close="$emit('close')"
  >
    <el-form ref="form" label-width="80px" :model="formData">
      <el-form-item label="处理意见" prop="reason">
        <el-input
          class="el-input !w-full"
          placeholder="请输入处理意见"
          maxlength="50"
          type="textarea"
          rows="3"
          v-model="formData.reason"
          size="small"
          clearable
        ></el-input>
      </el-form-item>
    </el-form>
    <div class="flex justify-center items-center">
      <el-button size="small" class="iconfont icon-close" @click="$emit('close')">取消</el-button>
      <el-button
        :loading="formLoading"
        size="small"
        type="primary"
        class="iconfont icon-save"
        @click="saveAdvice"
        >处理</el-button
      >
    </div>
  </CockpitDialog>
</template>

<script>
import CockpitDialog from '@/components/cockpit/CockpitDialog'
import { StandardAlarmRecordApi } from '@wiz-api/personnel-position'

const alarmRecordApi = new StandardAlarmRecordApi()

export default {
  name: 'deal-alarm-dialog',
  props: {
    propData: {
      default: '',
    },
  },
  components: {
    CockpitDialog,
  },
  watch: {},
  data() {
    return {
      formData: {
        reason: '',
      },
      formLoading: false,
    }
  },
  computed: {},
  methods: {
    saveAdvice() {
      // this.$emit('close')
      // const openEvent = new CustomEvent('refreshAlarmList')
      // window.dispatchEvent(openEvent)

      this.$refs.form.validate(async (valid) => {
        this.formLoading = true
        const [err, res] = await alarmRecordApi.confirmAlarm(this.propData.id, {
          advice: this.formData.reason,
        })

        if (!err) {
          this.$message({
            showClose: true,
            message: '处理成功',
            type: 'success',
          })
          this.$emit('close')
          const openEvent = new CustomEvent('refreshAlarmList')
          window.dispatchEvent(openEvent)
        }
        this.formLoading = false
      })
    },
  },
  created() {},
}
</script>

<style scoped lang="scss">
::v-deep .el-textarea__inner {
  border: 1px solid !important;
  border-color: var(--cockpitInputBorderColor) !important;
  background-color: var(--cockpitInputBgColor) !important;
  color: var(--cockpitInputFontColor) !important;

  &:hover {
    border-color: var(--cockpitInputHoverBorderColor) !important;
  }
}
</style>
